import App from './App.svelte';


const target = document.getElementById('appselector');
const configString = target.getAttribute('configuration');
const conf = JSON.parse(configString);

const app = new App({
	target: target,
	props: {
        configuration : conf
	}
});

export default app;